import React, {Suspense, useEffect} from 'react';
import SideMenubar from './DynamicSideMenubar';
import Header from './Header/Header';
import AppDownloadDialog from '../Component/AppDownloadDialog';
import {getLocaleTag, useLocale} from '../Localization/LocaleContext';
import RoleProtectedOutlet from './RoleProtectedOutlet';

const MainRootView = ({sideMenuConfigReady = true}) => {
  const {locale, translate} = useLocale();
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      return undefined;
    }

    const scriptId = 'tradly-freshworks-chat-widget';
    if (document.getElementById(scriptId)) {
      return undefined;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.src = 'https://in.fw-cdn.com/30092178/59824.js';
    script.setAttribute('chat', 'true');
    document.head.appendChild(script);

    return undefined;
  }, []);

  return (
    <div lang={getLocaleTag(locale)}>
      <AppDownloadDialog />
      <div
        style={{
          display: 'flex',
          height: '100vh',
          width: '100%',
          overflow: 'hidden',
          backgroundColor: 'var(--sidebar-bg, #01544E)',
        }}>
        <div
          className="hidden md:block shrink-0"
          style={{flexShrink: 0, minWidth: 56}}>
          <SideMenubar isConfigReady={sideMenuConfigReady} />
        </div>
        <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
          <Header sideMenuConfigReady={sideMenuConfigReady} />
          <div
            className="app-route-shell flex-1 overflow-y-auto overflow-x-auto min-w-0 bg-[var(--color-bg)] rounded-ss-2xl"
            style={{flex: 1, minWidth: 0, overflowY: 'auto', overflowX: 'auto'}}>
          <Suspense
            fallback={
              <div
                style={{
                  minHeight: 240,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--color-text-secondary, #5b6870)',
                }}>
            {translate("common.loading_page")}
              </div>
            }>
            <RoleProtectedOutlet />
          </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainRootView;
